import {Injectable} from "@angular/core";
import {MissingTranslationHandler, MissingTranslationHandlerParams} from "@ngx-translate/core";
import IMissingTranslationCommand = NCVIB.app.Main.Administration.Translation.IMissingTranslationCommand;
import { HttpClient } from "@angular/common/http";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {environment} from "../../../../environments/environment";
import {CoreService} from "../../../common/core.service";
import {ActivatedRoute, Router} from "@angular/router";

// AoT requires an exported function for factories
export function HttpLoaderFactory(httpClient: HttpClient) {
    return new TranslateHttpLoader(httpClient, environment.apiUrl + "api/v2/localization/get-translations/", "");
}

@Injectable({
    providedIn: 'root',  // or 'any' or specific module
})
export class CustomMissingTranslationHandler implements MissingTranslationHandler {
    private handledMissingTranslations: string[] = [];

    constructor(
        private core: CoreService,
        private router: Router) {
    }

    public handle(params: MissingTranslationHandlerParams): string {
        if (!this.handledMissingTranslations.some(x => x === params.key)) {
            this.handledMissingTranslations.push(params.key);

            let componentName = '';

            try {
                const stackTrace = new Error().stack || '';
                const matches = stackTrace.match(/at (\w+)Component/);

                if (matches && matches[1]) {
                    componentName = `${matches[1]}Component`;
                }
            } catch (error) {
                console.warn('Failed to parse stack trace:', error);
            }


            let command: IMissingTranslationCommand = {
                key: params.key,
                source: !!componentName ? `${this.router.url} [${componentName}]` : this.router.url
            };

            console.warn("Adding translation", params.key);
            this.core.post(
                `api/v2/administration/translation/missing-translation`,
                command,
                "Store missing translation key:" + params.key,
                false)
                .subscribe(() => {
                    console.log("Missing translation finished: " + params.key);
                });
        }

        return params.key;
    }
}
